<template>
    <div class="card" @click="openDetail">
        <div class="card-image">
            <img v-lazy="data.cover" />
            <span>查看详情</span>
            <div class="card-new" v-if="data.newCaseStatus === 1">
                新案例
            </div>
        </div>
        <div class="card-info">
            <div class="card-info__title">
                <span :title="data.title || ''">{{ data.title || '' }}</span>
            </div>
            <!-- <div class="card-info__introduction">
                <span :title="data.introduction || ''">{{ data.introduction || '' }}</span>
            </div> -->
            <div class="card-bottom">
                <!-- 项目案例 -->
                <div class="card-info__tag" v-if="data.classType === 3">
                    <span class="card-info__tag-item" v-for="item in data.classList" :key="item.id">
                        {{ item.name }}
                    </span>
                </div>
                <!-- 解决方案 -->
                <!-- <div class="card-info__price" v-if="data.classType === 2">
                    ￥{{data.price || '--'}}
                </div> -->
                <!-- 专业服务 -->
                <!-- <div class="card-info__service" v-if="data.classType === 1">
                    <img src="/static/images/user.png" alt="">
                    官方认证服务
                </div> -->
                <!-- <el-button type="primary" class="form-button">立即查看</el-button> -->
            </div>
            
        </div>
        <!-- <div class="card-btn">
            <el-button v-if="data.files" class="form-button" @click="handleClickShowVideo"><i class="el-icon-video-camera"></i>视频动画</el-button>
            <el-button  @click="openDetail"><i class="el-icon-document-copy"></i>完整案例</el-button>
            <el-button type="primary" class="form-button" @click="purposeRequest"><i class="el-icon-right"></i>我要同款</el-button>
        </div> -->
        <RequestForm v-if="showRequestForm" :showRequestForm.sync="showRequestForm" :projectInfo="data"/>
    </div>
</template>

<script>

    import { openWindow } from '@/utils/utils';
    import RequestForm from './RequestForm';
    export default {
        name: 'ServiceCard',
        components: {
            RequestForm,
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            showRequestForm: false, // 是否展示同款需求弹出框
        }),
        mounted() {
        },
        methods: {
            /**
             * 点击打开详情
             */
            openDetail() {
                // openWindow(`/#/projectCase/${this.data.id}`);
                this.$emit('set-project-case', this.data.id);
            },
            /**
             * 点击我要同款
             */
            purposeRequest() {
                this.showRequestForm = true;
            },
            /**
             * 点击展示视频动画
             */
            handleClickShowVideo() {
                this.$emit("show-video", this.data.id);
            }  
        }
    };
</script>

<style lang="scss" scoped>
.card {
    display: inline-block;
    // margin-top: 20px;
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    cursor: pointer;
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, .03), 0 8px 16px rgba(0, 0, 0, .02);
        transform: translate(0, -5px);
        transition: transform .3s;
    }

    &-new {
        width: 76px;
        height: 30px;
        background: #FA5151;
        opacity: 1;
        color: #fff;
        text-align: center;
        line-height: 30px;
        border-radius: 8px 0 8px 0;
        font-size: 16px;
        position: absolute;
        left: 0;
        top: 0;
    }
    &-image {
        position: relative;
        padding-bottom: 56.25%;
        box-shadow: 0px 2px 8px 0px rgba(153, 154, 172, 0.25);
        border-radius: 8px 8px 0 0;
        overflow: hidden;
        width: 100%;
        height: 242px;
        cursor: pointer;

        img {
            position: absolute;
            border-radius: 8px 8px 0 0;
            width: 100%;
            height: 100%;
            left: 0;
            top:0;
            object-fit: cover;
            transition: transform 0.35s;

            &:hover {
                transform: scale(1.05);
            }
        }
        span {
            position: absolute;
            display: none;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            width: 88px;
            height: 34px;
            // border-radius: 8px 8px 8px 8px;
            // border: 1px solid #FFFFFF;
            top: calc(50% - 17px);
            left: calc(50% - 44px);
        }
        &:hover {
            // background: #000000;
            // opacity: 0.8;
            span {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    &-info { 
        padding-bottom: 20px;
        &__title {
            display: flex;
            align-items: center;
            margin: 10px 20px 10px 12px;
            cursor: pointer;
            @include font(#272C40, 16px, 400);

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                    color: rgba(47, 84, 235, 1);
                }
            }
        }
        &__introduction {
            display: flex;
            align-items: center;
            height: 42px;
            padding: 0 20px 0 12px;
            @include font(#8C8C8C, 14px, 400);
            overflow: hidden;
            text-overflow: ellipsis;
            display:-webkit-box;
            -webkit-line-clamp:2;
            -webkit-box-orient:vertical;
        }
        &__tag {
            // margin: 10px 0 0 10px;
            height: 22px;
            line-height: 22px;
            &-item {
                margin: 10px 10px 0 0;
                // padding: 0 10px 0 0;
                border-radius: 12px;
                font-size: 12px;
                color: #666;
                cursor: pointer;
            }
        }
    }
    &-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        padding: 0 20px 0 12px;
        .card-info__tag {
            overflow: hidden;
            flex: 1;
            margin-right: 15px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .card-info__price {
            overflow: hidden;
            flex: 1;
            margin-right: 15px;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #EB793C;
            font-size: 18px;
            font-weight: 600;
        }
        .card-info__service {
            overflow: hidden;
            display: flex;
            align-items: center;
            flex: 1;
            margin-right: 15px;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            color: #3A3E50;
            img {
                width: 20px;
                height: 20px;
                border-radius: 100%;
                margin-right: 5px;
            }
        }
        /deep/ .el-button {
            padding: 10px 13px;
            border-radius: 6px;
            font-size: 16px;
            &--primary {
                border: 1px solid #E07727;
                background-color: #E07727;
                &:hover {
                    border: 1px solid #e29050;
                    background-color: #e29050;
                    box-shadow:0 4px 12px rgba(0, 0, 0, .12);
                }
            }
            &+.el-button {
                margin: 0;
            }
        }
    }
    &-btn {
        display: flex;
        justify-content: space-between;
        margin: 0 10px;
        padding: 15px 0;
        border-top: 1px solid #EEF0FE;
        /deep/ .el-button {
            padding: 8px 2%;
            border-radius: 2px;
            &--default {
                border: none;
                font-size: 13px;
                color: #666;
                &:hover {
                    background-color: #eaeefd;
                    color: #2f54eb;
                }
            }
            &--primary {
                border: 1px solid #E07727;
                background-color: #E07727;
                &:hover {
                    border: 1px solid #e29050;
                    background-color: #e29050;
                    box-shadow:0 4px 12px rgba(0, 0, 0, .12);
                }
            }
            &+.el-button {
                margin: 0;
            }
        }
        [class*='el-icon-'] {
            margin-right: 5px;
        }
    }
    &:hover {
        box-shadow: 0px 2px 4px 2px rgba(153, 154, 172, 0.1);
    }
}

// 小屏
@include mq($small) {
    .card {
        &-btn {
            /deep/ .el-button {
                padding: 8px 6px;
                font-size: 12px;
            }
            [class*='el-icon-'] {
                margin-right: 2px;
            }
        }
    }
}
</style>
